import { Description } from '../../common/decorators/description.decorator';

export class BusinessErrorEnum {
  // #region General business error
  @Description('Timeout')
  public static readonly timeout = 'TRNS.Timeout';
  @Description('StatusCodeError')
  public static readonly statusCodeError = 'TRNS.StatusCodeError';

  @Description('HasProcessQueuing')
  public static readonly hasProcessQueuing = 'TRNS.HasProcessQueuing';

  @Description('APIError')
  public static readonly APIError = 'TRNS.APIError';

  /** Transaction 失敗 */
  @Description('TransactionFailure')
  public static readonly transactionFailure = 'TRNS.TransactionFailure';

  /** 使用者不存在 */
  @Description('UserNotExist')
  public static readonly userNotExist = 'TRNS.UserNotExist';
  // #endregion General business error

  // #region commencement-apply(起租申請)
  /** 案件編號未核准或不存在 */
  @Description('CaseNotApprove')
  public static readonly CaseNotApprove = 'TRNS.CaseNotApprove';

  /** 起租案件不存在 */
  @Description('CaseIsNotExist')
  public static readonly CaseIsNotExist = 'TRNS.CaseIsNotExist';

  /** 起租前檢查項目: 審查作業相關追蹤事項必須處理完成 */
  @Description('PendingItemIsNotDone')
  public static readonly PendingItemIsNotDone = 'TRNS.PendingItemIsNotDone';

  /** 案件的snapshot不存在 */
  @Description('CommencementCaseSnapshotNotExist')
  public static readonly CommencementCaseSnapshotNotExist =
    'TRNS.CommencementCaseSnapshotNotExist';

  /** 起租案件已起租 */
  @Description('CaseAlreadyCommenced')
  public static readonly CaseAlreadyCommenced = 'TRNS.CaseAlreadyCommenced';

  /** 起租案件申請中 */
  @Description('CaseUnderApplying')
  public static readonly CaseUnderApplying = 'TRNS.CaseUnderApplying';

  /** 申請單號不存在 */
  @Description('FormNoNotExist')
  public static readonly FormNoNotExist = 'TRNS.FormNoNotExist';

  @Description('CaseNoNotExist')
  public static readonly CaseNoNotExist = 'TRNS.CaseNoNotExist';

  /** 披覆書到期日 */
  @Description('CaseExpired')
  public static readonly CaseExpired = 'TRNS.CaseExpired';

  /** 審查系統未核准或不存在 */
  @Description('CreditCaseNotApprovedOrNotExist')
  public static readonly CreditCaseNotApprovedOrNotExist =
    'TRNS.CreditCaseNotApprovedOrNotExist';

  /** CifNo 不存在 */
  @Description('CifNoIsNotExist')
  public static readonly CifNoIsNotExist = 'TRNS.CifNoIsNotExist';

  /** 部門ID不存在 */
  @Description('DeptIdNotExist')
  public static readonly DeptIdNotExist = 'TRNS.DeptIdNotExist';

  /** 申請單不存在 */
  @Description('ApplicationNotExist')
  public static readonly ApplicationNotExist = 'TRNS.ApplicationNotExist';

  /** 資料檢核未通過 */
  @Description('CheckCaseData')
  public static readonly CheckCaseData = 'TRNS.CheckCaseData';

  /** 起租申請狀態錯誤 */
  @Description('CommencementApplicationStatusError')
  public static readonly CommencementApplicationStatusError =
    'TRNS.CommencementApplicationStatusError';

  /** Customer Information: 客戶資料不正確 */
  @Description('CustomerInfoIncorrect')
  public static readonly CustomerInfoIncorrect = 'TRNS.CustomerInfoIncorrect';

  /** Collateral: Reg. Fee 必填(MY) */
  @Description('CollateralError')
  public static readonly CollateralError = 'TRNS.CollateralError';

  /** Collateral: PlateNo 必填 */
  @Description('PlateNoRequired')
  public static readonly PlateNoRequired = 'TRNS.PlateNoRequired';

  /** Collateral: 車輛已被設定 */
  @Description('VehicleAlreadySetting')
  public static readonly VehicleAlreadySetting = 'TRNS.VehicleAlreadySetting';

  /** Collateral: 擔保品設定單號尚未設定(MY 檢核)  */
  @Description('LienSerialNoNotSetting')
  public static readonly LienSerialNoNotSetting = 'TRNS.LienSerialNoNotSetting';

  /** Terms & Conditions: 暫收款邏輯錯誤 */
  @Description('TempPaymentError')
  public static readonly TempPaymentError = 'TRNS.TempPaymentError';

  @Description('SingleTempPaymentError')
  public static readonly SingleTempPaymentError = 'TRNS.SingleTempPaymentError';

  /** Repayment Schedule: 首次還款日需大於起租日且不得超過起租日2個月 */
  @Description('RePaymentDateError')
  public static readonly RePaymentDateError = 'TRNS.RePaymentDateError';

  /** Repayment Schedule: Payment Method必須固定為AUTO DEBIT */
  @Description('RePaymentMethodError')
  public static readonly RePaymentMethodError = 'TRNS.RePaymentMethodError';

  /** Disbursement Information: 撥款資訊錯誤 */
  @Description('DisbursementError')
  public static readonly DisbursementError = 'TRNS.DisbursementError';

  /** Disbursement Information: 撥款日設定錯誤 */
  @Description('DisbursementDateError')
  public static readonly DisbursementDateError = 'TRNS.DisbursementDateError';

  /** Disbursement Information: 結清金額檢核錯誤 */
  @Description('SettlementPriceError')
  public static readonly SettlementPriceError = 'TRNS.SettlementPriceError';

  /** Check List: 確認事項未同意 */
  @Description('CheckListNotApproved')
  public static readonly CheckListNotApproved = 'TRNS.CheckListNotApproved';
  // #endregion commencement-apply(起租申請)

  // #region restore(起租還原)
  /** 主狀態非起租核准或起租生效（正常） */
  @Description('MainStatusIsInvalid')
  public static readonly MainStatusIsInvalid = 'TRNS.MainStatusIsInvalid';

  /** 子狀態非正常 */
  @Description('SubStatusIsNotNormal')
  public static readonly SubStatusIsNotNormal = 'TRNS.SubStatusIsNotNormal';

  /** 撥款狀態非未撥款 */
  @Description('DsbStatusIsNotUnDisbursement')
  public static readonly DsbStatusIsNotUnDisbursement =
    'TRNS.DsbStatusIsNotUnDisbursement';

  /** 借新還舊，舊案件未結清 */
  @Description('RefinanceSubStatusIsNotSettlement')
  public static readonly RefinanceSubStatusIsNotSettlement =
    'TRNS.RefinanceSubStatusIsNotSettlement';

  /** 已付過第一期款 */
  @Description('AlreadyFirstRePayment')
  public static readonly AlreadyFirstRePayment = 'TRNS.AlreadyFirstRePayment';

  /** 關鍵服務狀態不存在 */
  @Description('MainStatusIsNotExist')
  public static readonly MainStatusIsNotExist = 'TRNS.MainStatusIsNotExist';
  // #endregion restore(起租還原)

  // #region export-document-contract(文件產製)
  /** 申請單已存在 */
  @Description('ApplicationInProcess')
  public static readonly ApplicationInProcess = 'TRNS.ApplicationInProcess';

  /** 文件尚未匯出 */
  @Description('CaseNotExport')
  public static readonly CaseNotExport = 'TRNS.CaseNotExport';

  /** 起租案件無法更新 */
  @Description('CaseIsNotEditable')
  public static readonly CaseIsNotEditable = 'TRNS.CaseIsNotEditable';

  /** 檔案下載失敗 */
  @Description('DownloadFailed')
  public static readonly DownloadFailed = 'TRNS.DownloadFailed';

  /** 無指定樣板 */
  @Description('NoPrintTemplate')
  public static readonly NoPrintTemplate = 'TRNS.NoPrintTemplate';

  /** 案件套印失敗 */
  @Description('DocumentPrintFail')
  public static readonly DocumentPrintFail = 'TRNS.DocumentPrintFail';

  /** 文件產製流程尚未結束 */
  @Description('DocumentProcessNotFinish')
  public static readonly DocumentProcessNotFinish =
    'TRNS.DocumentProcessNotFinish';

  /** 文件產製提示案件狀態變更中 */
  @Description('CreditChanging')
  public static readonly CreditChanging = 'TRNS.CreditChanging';

  /** 文件產製：auto-life form 無報價單時提示訊息 */
  @Description('InsuranceQuotationNotFound')
  public static readonly InsuranceQuotationNotFound =
    'TRNS.InsuranceQuotationNotFound';
  // #endregion export-document-contract(文件產製)

  // #region contract-amendment(起租變更)
  /** 起租變更: VcifLockError */
  // @Description('VcifLockError')
  // public static readonly VcifLockError = 'TRNS.VcifLockError';

  /** 起租變更: 當日撥款單尚未作廢，請進行撥款單刪除處理 */
  @Description('DisbursementNotWithdrawn')
  public static readonly DisbursementNotWithdrawn =
    'TRNS.DisbursementNotWithdrawn';

  /** 沖抵案件查無對應核銷系統資料 */
  @Description('DisbursementNotFound')
  public static readonly DisbursementNotFound = 'TRNS.DisbursementNotFound';

  /** 沖抵案件該案件金額已異動 */
  @Description('DisbursementAmountChanged')
  public static readonly DisbursementAmountChanged =
    'TRNS.DisbursementAmountChanged';

  /** 申請人非原申請者或直屬主管 */
  @Description('ApplicantNotAllowed')
  public static readonly ApplicantNotAllowed = 'TRNS.ApplicantNotAllowed';

  /** billingAccount資金水位不足撥款 */
  @Description('AccountingSettingFundError')
  public static readonly AccountingSettingFundError =
    'TRNS.AccountingSettingFundError';

  /** 有帳戶但水位不夠 */
  @Description('FundsFail')
  public static readonly FundsFail = 'TRNS.FundsFail';

  /** 當日撥款卻找不到符合條件的對應帳戶 */
  @Description('AccountingFail')
  public static readonly AccountingFail = 'TRNS.AccountingFail';

  /** RegFee 為必填 */
  @Description('RegFeeError')
  public static readonly RegFeeError = 'TRNS.RegFeeError';

  /** 關卡尚未結束，但無下一處理人員 */
  @Description('AssignerNoExist')
  public static readonly AssignerNoExist = 'TRNS.AssignerNoExist';

  /** 供應商不存在 */
  @Description('DealerNotExist')
  public static readonly DealerNotExist = 'TRNS.DealerNotExist';

  /** 傳票尚未作廢 */
  @Description('AHNotInvalid')
  public static readonly AHNotInvalid = 'TRNS.AHNotInvalid';

  /** 起租AccountHub TransactionId不存在 */
  @Description('AHTransactionIdNotFound')
  public static readonly AHTransactionIdNotFound =
    'TRNS.AHTransactionIdNotFound';
  // #endregion contract-amendment(起租變更)

  /** 起租申請，起租變更 - 起租日不可跨月分 */
  @Description('CommencementDateMonthlyError')
  public static readonly CommencementDateMonthlyError =
    'TRNS.CommencementDateMonthlyError';

  /** 起租申請，起租變更 - 撥款日跟起租日不同月 */
  @Description('CommencementDibursementDateNotSameMonth')
  public static readonly CommencementDibursementDateNotSameMonth =
    'TRNS.CommencementDibursementDateNotSameMonth';

  /** 首期還款日與第一期日期相符才能送出之檢核 */
  @Description('FirstPaymentDateMismatch')
  public static readonly FirstPaymentDateMismatch =
    'TRNS.FirstPaymentDateMismatch';

  /** 輔導員名單的新增功能，在輔導間內已存在輔導員設定 */
  @Description('CounselorAlreadyExisted')
  public static readonly CounselorAlreadyExisted =
    'TRNS.CounselorAlreadyExisted';

  /**此案件已處理，請勿重覆處理。 */
  @Description('ReceiveConfirmationCaseClosed')
  public static readonly ReceiveConfirmationCaseClosed =
    'TRNS.ReceiveConfirmationCaseClosed';

  /**此案件已逾請款期限。 */
  @Description('ReceiveConfirmationCaseOverdue')
  public static readonly ReceiveConfirmationCaseOverdue = 'TRNS.CaseOverdue';

  /**此案件已由{form.Assignee}進行收件確認，請問是否要將目前處理人員變更為您? */
  @Description('ReceiveConfirmationCaseAssignedAlready')
  public static readonly ReceiveConfirmationCaseAssignedAlready =
    'TRNS.ReceiveConfirmationCaseAssignedAlready';

  /**請至少新增一筆電話聯絡紀錄 */
  @Description('TeleContactRecordNotExsits')
  public static readonly TeleContactRecordNotExsits =
    'TRNS.TeleContactRecordNotExsits';

  /**供應商目前與新指派業務為同一位 */
  @Description('CurrentAndNewSalesIdentical')
  public static readonly CurrentAndNewSalesIdentical =
    'TRNS.CurrentAndNewSalesIdentical';

  /**客戶尚有在途件 */
  @Description('CustomerNotClosedStatus')
  public static readonly CustomerNotClosedStatus =
    'TRNS.CustomerNotClosedStatus';

  /**案件狀態無法編輯 */
  @Description('CaseNotEditable')
  public static readonly CaseNotEditable = 'TRNS.CaseNotEditable';

  /**案件狀態已作廢無法編輯 */
  @Description('CaseWithdrawn')
  public static readonly CaseWithdrawn = 'TRNS.CaseWithdrawn';

  /**供應商已存在錯誤 */
  @Description('PreviousDealerExist')
  public static readonly PreviousDealerExist = 'TRNS.PreviousDealerExist';

  /**身分證重複錯誤 */
  @Description('DuplicateIdentityNo')
  public static readonly DuplicateIdentityNo = 'TRNS.DuplicateIdentityNo';

  /**系統參數不明錯誤 */
  @Description('SystemParameterFail')
  public static readonly SystemParameterFail = 'TRNS.SystemParameterFail';

  /**VCIF新增或更新錯誤 */
  @Description('VcifCreateOrUpdateError')
  public static readonly VcifCreateOrUpdateError =
    'TRNS.VcifCreateOrUpdateError';

  /**VCIF解鎖錯誤 */
  @Description('VcifUnlockError')
  public static readonly VcifUnlockError = 'TRNS.VcifUnlockError';

  /**資料被鎖住無法編輯錯誤 */
  @Description('Library.ErrorCode.VcifLocked')
  public static readonly VcifLocked = 'TRNS.VcifLocked';

  /**因客戶統編CIFNo與VCIF系統的CIFNo 比對不一致，需請洽IT人員 */
  @Description('CifnoNotMatched')
  public static readonly CifnoNotMatched = 'TRNS.CifnoNotMatched';

  /**VCIF已有資料錯誤 */
  @Description('VcifAlreadyHasData')
  public static readonly VcifAlreadyHasData = 'TRNS.VcifAlreadyHasData';

  /**案件退回 */
  @Description('CaseReturned')
  public static readonly CaseReturned = 'TRNS.CaseReturned';

  /**案件批覆書審核中錯誤 */
  @Description('OnGoingApproval')
  public static readonly OnGoingApproval = 'TRNS.OnGoingApproval';
  /**評分表相同產品類別、產業類別之資料已存在 */
  @Description('ExistProductCodeAndIndustryCode')
  public static readonly ExistProductCodeAndIndustryCode =
    'TRNS.ExistProductCodeAndIndustryCode';
  /**評分表重複編輯 */
  @Description('DuplicateEdit')
  public static readonly DuplicateEdit = 'TRNS.DuplicateEdit';
  /**已有重複產品類別批覆書 */
  @Description('DealerAppRepeatErr')
  public static readonly DealerAppRepeatErr = 'TRNS.DealerAppRepeatErr';

  /**寄mail錯誤 */
  @Description('SendMailFail')
  public static readonly SendMailFail = 'TRNS.SendMailFail';

  /**寄mail錯誤 */
  @Description('SendSMSFail')
  public static readonly SendSMSFail = 'TRNS.SendSmsFail';

  /** 供應商不存在 */
  @Description('DealerIsNotExist')
  public static readonly DealerIsNotExist = 'TRNS.DealerIsNotExist';
  /** 評分表欄位值存在重複 */
  @Description('ColumnValueDuplicate')
  public static readonly ColumnValueDuplicate = 'TRNS.ColumnValueDuplicate';

  /**不是負責的業務錯誤 */
  @Description('NotTheResponsibleSales')
  public static readonly NotTheResponsibleSales = 'TRNS.NotTheResponsibleSales';

  /**非該供應商負責業務人員之上層主管錯誤 */
  @Description('NotTheResponsibleManager')
  public static readonly NotTheResponsibleManager =
    'TRNS.NotTheResponsibleManager';

  /** 不存在於供應商基本資料檔 */
  @Description('DBDataBaseInfoNull')
  public static readonly DBDataBaseInfoNull = 'TRNS.DBDataBaseInfoNull';

  /** 不存在於供應商階層檔 */
  @Description('DBDataLevelNull')
  public static readonly DBDataLevelNull = 'TRNS.DBDataLevelNull';

  /** 地址不完整，無法產生Dealer Code */
  @Description('NoAddressLevel1Found')
  public static readonly NoAddressLevel1Found = 'TRNS.NoAddressLevel1Found';

  /** 供應商沒有統編/身分證號，無法申請 */
  @Description('NoDealerIdentityNoFound')
  public static readonly NoDealerIdentityNoFound =
    'TRNS.NoDealerIdentityNoFound';

  /** 上層公司沒有有效的批覆書 */
  @Description('DBDataApprovalNull')
  public static readonly DBDataApprovalNull = 'TRNS.DBDataApprovalNull';

  /** 該集團或獨立戶尚有批覆書正在進行批覆書申請或條件變更申請 */
  @Description('BpmOnApprovalErr')
  public static readonly BpmOnApprovalErr = 'TRNS.BpmOnApprovalErr';

  /** 供應商非為正常戶，無法申請 */
  @Description('DealerInfoError')
  public static readonly DealerInfoError = 'TRNS.DealerInfoError';

  /** Dealer Code有誤，請確認後重新輸入 */
  @Description('DealerCodeError')
  public static readonly DealerCodeError = 'TRNS.DealerCodeError';

  /** 供應商非為正常戶，無法申請 */
  @Description('DealerStatusError')
  public static readonly DealerStatusError = 'TRNS.DealerStatusError';

  /** 供應商狀態尚未啟用，無法申請 */
  @Description('DealerEnableError')
  public static readonly DealerEnableError = 'TRNS.DealerEnableError';

  /** 供應商尚無有效批覆書，無法申請 */
  @Description('DealerApprovalNull')
  public static readonly DealerApprovalNull = 'TRNS.DealerApprovalNull';

  /** 供應商主要經營者不可進行申請 */
  @Description('DealerBoardDirectorCantApply')
  public static readonly DealerBoardDirectorCantApply =
    'TRNS.DealerBoardDirectorCantApply';

  /** 批覆書案件已到期，無法申請 */
  @Description('DealerApprovalExpired')
  public static readonly DealerApprovalExpired = 'TRNS.DealerApprovalExpired';

  /** 消費者案件已進行收件確認，無法申請 */
  @Description('CaseRequestingPayment')
  public static readonly CaseRequestingPayment = 'TRNS.CaseRequestingPayment';

  /** 消費者案件已超逾請款期間，無法申請 */
  @Description('CaseRequestPaymentOverdue')
  public static readonly CaseRequestPaymentOverdue =
    'TRNS.CaseRequestPaymentOverdue';

  /** 案件編號不存在 */
  @Description('CaseNoNotFound')
  public static readonly CaseNoNotFound = 'TRNS.CaseNoNotFound';
  /** 案件不符合重審規則 */
  @Description('CaseNotQualifiedReReviewRules')
  public static readonly CaseNotQualifiedReReviewRules =
    'TRNS.CaseNotQualifiedReReviewRules';
  /** 案件已超逾重審次數 */
  @Description('OverCaseRemandTimes')
  public static readonly OverCaseRemandTimes = 'TRNS.OverCaseRemandTimes';
  /** 供應商無權限 */
  @Description('NoDealerLevelPermission')
  public static readonly NoDealerLevelPermission =
    'TRNS.NoDealerLevelPermission';
  /** 審核結果與負表主管核決結果不符，請調整後再行送出 */
  @Description('NegativeRejectNotApproval')
  public static readonly NegativeRejectNotApproval =
    'TRNS.NegativeRejectNotApproval';
  /** 尚有會辦流程未結束，無法執行送出 */
  @Description('BpmBusiness')
  public static readonly BpmBusiness = 'TRNS.BpmBusiness';
  /** 該供應商資料或旗下供應商的供應商資料覆核中 */
  @Description('DealerBaseInfoHaveAudit')
  public static readonly DealerBaseInfoHaveAudit =
    'TRNS.DealerBaseInfoHaveAudit';
  /** 該供應商階層或旗下供應商的供應商階層覆核中 */
  @Description('DealerLevelHaveAudit')
  public static readonly DealerLevelHaveAudit = 'TRNS.DealerLevelHaveAudit';
  /** 無批覆書資料 */
  @Description('DealerChgAppFormNull')
  public static readonly DealerChgAppFormNull = 'TRNS.DealerChgAppFormNull';
  /** 請填寫批示意見 */
  @Description('InstructionRecordNullErr')
  public static readonly InstructionRecordNullErr =
    'TRNS.InstructionRecordNullErr';
  /** 批示意見送出不得為退回類，請檢查按鈕是否綁定正確退回功能 */
  @Description('InstructionRecordSentReturnErr')
  public static readonly InstructionRecordSentReturnErr =
    'TRNS.InstructionRecordSentReturnErr';
  /** 批示意見結果非核准或婉拒 */
  @Description('FinInstructionRecordErr')
  public static readonly FinInstructionRecordErr =
    'TRNS.FinInstructionRecordErr';
  /** 不存在審查意見 */
  @Description('CreditCommentNullErr')
  public static readonly CreditCommentNullErr = 'TRNS.CreditCommentNullErr';
  /** 關聯戶主檔更新錯誤 */
  @Description('ReturnRelatedGroupErr')
  public static readonly ReturnRelatedGroupErr = 'TRNS.ReturnRelatedGroupErr';
  /** 批示意見審查結果不在此關退回項目之一 */
  @Description('InstructionRecordReturnCodeErr')
  public static readonly InstructionRecordReturnCodeErr =
    'TRNS.InstructionRecordReturnCodeErr';
  /** 該集團尚有批覆書正在進行批覆書申請或條件變更申請 */
  @Description('BpmOnApprovalModifyErr')
  public static readonly BpmOnApprovalModifyErr = 'TRNS.BpmOnApprovalModifyErr';
  /** 沒有設定權限表額度資料 */
  @Description('NoLimitSettingErr')
  public static readonly NoLimitSettingErr = 'TRNS.NoLimitSettingErr';
  /** 沒有設定權限表利率資料 */
  @Description('NoInterestRateSettingErr')
  public static readonly NoInterestRateSettingErr =
    'TRNS.NoInterestRateSettingErr';
  /** 沒有該商品資料利率設定 */
  @Description('NoProductInterestRateSettingErr')
  public static readonly NoProductInterestRateSettingErr =
    'TRNS.NoProductInterestRateSettingErr';
  /** 此產業類別審核權限尚未生效，無法承作此產業類別 */
  @Description('NoProductInterestRateSettingErr2')
  public static readonly NoProductInterestRateSettingErr2 =
    'TRNS.NoProductInterestRateSettingErr2';
  /** 請調整收益率 */
  @Description('AdjustIRRErr')
  public static readonly AdjustIRRErr = 'TRNS.AdjustIRRErr';
  /** 計算權限主管錯誤 */
  @Description('CalculateApproveLevelErr')
  public static readonly CalculateApproveLevelErr =
    'TRNS.CalculateApproveLevelErr';
  /** 所選總公司沒有有效批覆書 */
  @Description('UpAppFormNotFound')
  public static readonly UpAppFormNotFound = 'TRNS.UpAppFormNotFound';
  /** 發查結果未完成 */
  @Description('CreditCheckNoData')
  public static readonly CreditCheckNoData = 'TRNS.CreditCheckNoData';
  /** 供應商列為黑名單 */
  @Description('CreditCheckDataOnlyReject')
  public static readonly CreditCheckDataOnlyReject =
    'TRNS.CreditCheckDataOnlyReject';
  /** 重複比對結果未完成 */
  @Description('DuplicateRecordNoData')
  public static readonly DuplicateRecordNoData = 'TRNS.DuplicateRecordNoData';
  /** 申請額度超過公司額度 */
  @Description('AppFormGreateThanUpAppFormAmount')
  public static readonly AppFormGreateThanUpAppFormAmount =
    'TRNS.AppFormGreateThanUpAppFormAmount';
  /** 已申請並結案婉拒在N天內不得再申請 */
  @Description('DealerAppCheckNewAppDays')
  public static readonly DealerAppCheckNewAppDays =
    'TRNS.DealerAppCheckNewAppDays';
  /** 展期人員卡控重覆簽送 */
  @Description('AlreadyExistAssignee')
  public static readonly AlreadyExistAssignee = 'TRNS.AlreadyExistAssignee';
  /** 批覆書申請類型暫存錯誤 */
  @Description('SaveAppFormCaseTypeErr')
  public static readonly SaveAppFormCaseTypeErr = 'TRNS.SaveAppFormCaseTypeErr';
  /** 本客戶已有流程中或3日內進件的資料，確定是否發送嗎？ */
  @Description('App.ErrorCode.preCheckFailed')
  public static readonly PreCheckFailed = 'TRNS.PreCheckFailed';

  /** case already process end */
  @Description('App.ErrorCode.otherCustomerServiceHasDone')
  public static readonly OtherCustomerServiceHasDone =
    'TRNS.OtherCustomerServiceHasDone';

  /** associatedCaseNo : {associatedCaseNo} does not exist! */
  @Description('App.ErrorCode.caseNumberNotExist')
  public static readonly CaseNumberNotExist = 'TRNS.CaseNumberNotExist';

  /** case {associatedCaseNo}  not belongs subject supplier */
  @Description('App.ErrorCode.dealerInfoNotMatch')
  public static readonly DealerInfoNotMatch = 'TRNS.DealerInfoNotMatch';
  /** {案件編號}不可重複輸入 */
  @Description('App.ErrorCode.caseNumberCantBeDuplicate')
  public static readonly CaseNumberCantBeDuplicate =
    'TRNS.CaseNumberCantBeDuplicate';
  /** {DealerId} + <空白> + {供應商名稱} + "狀態不得申覆" */
  @Description('App.ErrorCode.dealerStatusNotAllowAppeal')
  public static readonly DealerStatusNotAllowAppeal =
    'TRNS.DealerStatusNotAllowAppeal';
  /** 無讀取權限 */
  @Description('App.ErrorCode.noPermission')
  public static readonly NoPermission = 'TRNS.NoPermission';
  /** 其他BPM錯誤 */
  @Description('Library.ErrorCode.BpmErr')
  public static readonly BpmErr = 'TRNS.BpmErr';
  /**Dealer Web批覆書如果有錯時的訊息 */
  @Description('App.Hint.dealerAppCrdError')
  public static readonly DealerAppCrdError = 'TRNS.DealerAppCrdError';

  /**Dealer Web重設密碼申請錯誤 */
  @Description('App.Hint.resetPwdFailed')
  public static readonly ResetPasswordIsFailed = 'TRNS.ResetPasswordIsFailed';
  /** vcif錯誤 */
  @Description('Library.ErrorCode.CifNoCantBeFoundByIdNo')
  public static readonly vcifErr = 'CifNoCantBeFoundByIdNo';
  /** 此案件階段已更新，請勿重覆送件 */
  @Description('App.ErrorCode.caseInfoInconsistent')
  public static readonly CaseInfoInconsistent = 'TRNS.CaseInfoInconsistent';

  /** 案件目前處於起租流程(變更中)，無法進行審查變更。 */
  @Description('App.ErrorCode.caseInCommencementAmendInProcess')
  public static readonly CaseInCommencementAmendInProcess =
    'TRNS.CaseInCommencementAmendInProcess';

  /** 案件目前處於起租流程(還原中)，無法進行審查變更。 */
  @Description('App.ErrorCode.caseInCommencementRestoreInProcess')
  public static readonly CaseInCommencementRestoreInProcess =
    'TRNS.CaseInCommencementRestoreInProcess';

  /** 案件目前處於起租申請中，無法進行審查變更。 */
  @Description('App.ErrorCode.caseInCommencementApplyInProcess')
  public static readonly CaseInCommencementApplyInProcess =
    'TRNS.CaseInCommencementApplyInProcess';
}
